// public/klaro-config.js
const klaroConfig = {
  storageMethod: 'cookie', // Store consent in cookies
  storageName: 'klaro-cookie', // Cookie name
  acceptAll: true, // Show an accept all button
  hideDeclineAll: false, // Show a decline all button
  cookieName: 'klaro',
  elementID: 'cookie-banner', // ID of the banner container
  mustConsent: true, // Show the modal on first visit
  services: [
    {
      name: 'klaro',
      title: 'Klaro!',
      purposes: ['essential'],
      required: true,
    },
    {
      name: "klaro",
      title: "Klaro!",
      default: true,
      purposes: ["essential"],
      required: true,
    },
    {
      name: 'google-tag-manager',
      required: true,
      purposes: ['functional'],
      onAccept: `
        for(let k of Object.keys(opts.consents)){
            if (opts.consents[k]){
                let eventName = 'klaro-'+k+'-accepted'
                dataLayer.push({'event': eventName})
            }
        }
      `,
      onInit: `
        window.dataLayer = window.dataLayer || [];
        window.gtag = function(){dataLayer.push(arguments)}
        gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'})
        gtag('set', 'ads_data_redaction', true)
      `,
    },
    {
      name: 'google-analytics',
      cookies: [/^_ga(_.*)?/],
      purposes: ['performance'],
      onAccept: `
        gtag('consent', 'update', {
            'analytics_storage': 'granted',
        })
      `,
      onDecline: `
        gtag('consent', 'update', {
            'analytics_storage': 'denied',
        })
      `,
    },
    {
      name: 'google-ads',
      cookies: [],
      purposes: ['marketing'],
      onAccept: `
        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted'
        })
      `,
      onDecline: `
        gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied'
        })
      `,
    },
    {
      name: "meta-pixel",
      title: "Meta Pixel",
      purposes: ["marketing"],
      cookies: [["_fbp", "/", ".dotsandlines.io"]],
      required: false,
      onAccept: `
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'klaro-meta-pixel-accepted'});
      `,
      onDecline: `
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'klaro-meta-pixel-declined'});
      `,
    },
    {
      name: "google-double-click",
      title: "Google Double Click",
      purposes: ["marketing"],
      cookies: [
        ["IDE", "/", ".doubleclick.net"],
      ],
      required: false,
      onAccept: `
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'klaro-doubleclick-accepted'});
      `,
      onDecline: `
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'klaro-doubleclick-declined'});
      `,
    },
    {
      name: "linkedin",
      title: "LinkedIn",
      purposes: ["marketing"],
      cookies: [
        ["bscookie", "/", ".linkedin.com"],
        ["li_gc", "/", ".linkedin.com"],
        ["lidc", "/", ".linkedin.com"],
        ["UserMatchHistory", "/", ".linkedin.com"],
        ["AnalyticsSyncHistory", "/", ".linkedin.com"],
        ["bcookie", "/", ".linkedin.com"],
        ["lang", "/", ".linkedin.com"],
        ["ln_or", "/", ".linkedin.com"],
        ["ln_or", "/", "www.dotsandlines.io"],
      ],
      required: false,
      onAccept: `
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'klaro-linkedin-accepted'});
      `,
      onDecline: `
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({'event': 'klaro-linkedin-declined'});
      `,
    },
  ],
  translations: {
    de: {
      lang: 'de',
      privacyPolicyUrl: '/datenschutz',
      consentModal: {
        title: 'Datenschutz-Einstellungen',
        description: 'Hier kannst du einstellen, welche Dienste verwendet werden dürfen.',
      },
      googleAnalytics: {
        description: 'Statistik über Nutzerverhalten.',
      },
      purposes: {
        analytics: 'Statistiken',
      },
      acceptSelected: 'Auswahl speichern',
      decline: 'Essenzielle Cookies',
    },
    en: {
      lang: 'en',
      privacyPolicyUrl: '/en/privacy-policy',
      consentNotice: {
        description: 'We use cookies to enhance your browsing experience. Learn more in our {privacyPolicy}.',
        learnMore: 'Manage Preferences',
      },
      consentModal: {
        title: 'Cookie Preferences',
        description: 'We use cookies for the following purposes. You can manage your preferences below.',
      },
      ok: 'Accept all',
      decline: 'Essential Cookies',
      acceptSelected: 'Accept Selected',
      save: 'Save',
      close: 'Close',
      acceptAll: 'Accept All',
      googleAnalytics: {
        title: 'Google Analytics',
        description: 'Helps us understand and improve user experience on our website.',
      },
    }
  },
};

export default klaroConfig
